'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// eslint-disable-line import/no-extraneous-dependencies

var IdleTimeOutHandler = function (_Component) {
  _inherits(IdleTimeOutHandler, _Component);

  function IdleTimeOutHandler(props) {
    _classCallCheck(this, IdleTimeOutHandler);

    var _this = _possibleConstructorReturn(this, (IdleTimeOutHandler.__proto__ || Object.getPrototypeOf(IdleTimeOutHandler)).call(this, props));

    var logOutTimer = props.timeout ? +props.timeout : 15 * 60 * 1000;
    var warningTimer = props.warningTime ? +props.warningTime : logOutTimer - 60 * 1000;
    _this.state = {
      warningTimer: warningTimer,
      logOutTimer: logOutTimer,
      reLoginURL: props.reLoginURL || '/smc/customer',
      extendSessionURL: props.extendSessionURL,
      warningMessage: props.warningMessage,
      logoutMessage: props.logoutMessage,
      extendSessionBtnTxt: props.extendSessionBtnTxt

    };
    _this.resetTimer = _this.resetTimer.bind(_this);
    _this.serverRefresh = _this.serverRefresh.bind(_this);
    return _this;
  }

  _createClass(IdleTimeOutHandler, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window.warning2 = undefined;
      window.reLogin = undefined;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.resetTimer();
      _axios2.default.interceptors.request.use(function (config) {
        _this2.resetTimer();
        return config;
      }, function (error) {
        return Promise.reject(error);
      });
    }
  }, {
    key: 'serverRefresh',
    value: function serverRefresh() {
      var _this3 = this;

      if (!this.state.extendSessionURL) {
        window.location.reload(true);
      } else {
        _axios2.default.get(this.state.extendSessionURL, function () {
          _this3.resetTimer();
        }, function () {
          window.location = _this3.state.reLoginURL;
        });
      }
    }
  }, {
    key: 'resetTimer',
    value: function resetTimer() {
      var _this4 = this;

      window.clearTimeout(window.warning2);
      window.clearTimeout(window.reLogin);
      this.setState({ showWarning: false });
      warning2 = window.setTimeout( //  eslint-disable-line no-undef
      function () {
        _this4.setState({ showWarning: true });
      }, this.state.warningTimer);
      reLogin = window.setTimeout( //  eslint-disable-line no-undef
      function () {
        _this4.setState({ showWarning: false });
        // adding support for webview logout
        if (window.venice && window.venice.reAuth && typeof window.venice.reAuth === 'function') {
          window.venice.reAuth();
        } else {
          window.location = _this4.state.reLoginURL;
        }
      }, this.state.logOutTimer);
    }
  }, {
    key: 'render',
    value: function render() {
      var element = _react2.default.createElement('div', null);
      if (this.state.showWarning) {
        element = _react2.default.createElement(
          'div',
          {
            id: 'myNav',
            className: 'overlay',
            tabIndex: '0',
            ref: function ref(MyNaveRef) {
              if (MyNaveRef) {
                MyNaveRef.focus();
              }
            }
          },
          _react2.default.createElement(
            'div',
            { className: 'overlay-content', role: 'alert', tabIndex: '0' },
            _react2.default.createElement('div', { className: 'vx_icon vx_icon-large vx_icon-attention-large' }),
            _react2.default.createElement(
              'div',
              { className: 'warning_message' },
              this.state.warningMessage
            ),
            _react2.default.createElement(
              'div',
              { className: 'logout_message' },
              this.state.logoutMessage,
              ' '
            ),
            _react2.default.createElement(
              'a',
              { onClick: this.serverRefresh, tabIndex: '0', className: 'vx_btn vx_btn-primary vx_btn-lg' },
              this.state.extendSessionBtnTxt
            )
          )
        );
      }
      return element;
    }
  }]);

  return IdleTimeOutHandler;
}(_react.Component);

IdleTimeOutHandler.propTypes = {
  timeout: _propTypes2.default.string,
  warningTime: _propTypes2.default.string,
  reLoginURL: _propTypes2.default.string,
  extendSessionURL: _propTypes2.default.string,
  warningMessage: _propTypes2.default.string.isRequired,
  logoutMessage: _propTypes2.default.string.isRequired,
  extendSessionBtnTxt: _propTypes2.default.string.isRequired
};

exports.default = IdleTimeOutHandler;